const liveComponents = {
  en: {
    liveComponents: {
      live: "LIVE",
      offline: "Offline",
      updatedAt: "Updated {{time}}",
      stationsReporting: "Stations Reporting",
      totalVotes: "Total Votes",
      turnout: "Turnout",
      lastUpdate: "Last Update",
      currentStandings: "Current Standings",
      liveUpdates: "Live Updates"
    }
  },
  fr: {
    liveComponents: {
      live: "EN DIRECT",
      offline: "Hors ligne",
      updatedAt: "Mis à jour à {{time}}",
      stationsReporting: "Bureaux de vote ayant transmis",
      totalVotes: "Total des votes",
      turnout: "Participation",
      lastUpdate: "Dernière mise à jour",
      currentStandings: "Classement actuel",
      liveUpdates: "Mises à jour en direct"
    }
  }
};

export default liveComponents;
